(ns net.kestec.mhda-pilgrimage.public.news.widgets.public-news-block
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Card" :default Card]
    ["@mui/material/CardContent" :default CardContent]
    ["@mui/material/Collapse" :default Collapse]
    ["@mui/material/CircularProgress" :default CircularProgress]
    ["@mui/icons-material/ExpandMore" :default ExpandMoreIcon]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.util.date :refer [format-ger]]
    [net.kestec.mhda-pilgrimage.route :as route]
    [re-frame.core :as rf]
    [reagent.core :as r]
    ))


(rf/reg-event-fx
  ::set-expand
  (fn [{db :db} [_ t]]
    {:dispatch [::route/push
                (:name (:data (::route/route db)))
                :path-params (:path-params (::route/route db))
                :query-params (assoc (:query-params (::route/route db))
                                :g-news t)]}))


(rf/reg-sub
  ::get-expand
  (fn [{:as db {:keys [query-params]} ::route/route} _]
    (or (:g-news query-params) "1")))


(defn article-block [article]
  [:div
   [:> Typography {:variant "p" :color "secondary"} (format-ger (:news_date article))]
   [:p {:dangerouslySetInnerHTML
        (r/unsafe-html (str (:msg article)))}]])


(defn public-news-block []
  (let [news @(rf/subscribe [::db/get ::db/my-news])
        expand? (= "1" @(rf/subscribe [::get-expand]))]
    [:> Card
     [:> CardContent
      [:> Typography {:variant "h2"} "Öffentliche Neuigkeiten zu Rom 2026"
       [:> ExpandMoreIcon
        {:style         {:float "right" :transform (if expand? "rotate(0deg)" "rotate(180deg)")}
         :expand        expand?
         :onClick       #(rf/dispatch [::set-expand (if expand? "0" "1")])
         :aria-expanded expand?
         :aria-label    "show more"}]]
      (into
        [:> Collapse {:in expand? :timeout "auto"}]
        (if (:globalNews news)
          (for [article (:globalNews news)]
            (article-block article)
            )
          [[:> CircularProgress {:size "20px"}]]))
      ]]))